import type { WheelEvent } from 'react';

/**
 * Wheel handler for horizontally-scrolling strips (folder tabs, server rail).
 *
 * A mouse wheel only produces vertical deltas, so a no-scrollbar
 * `overflow-x-auto` row is unreachable past its edge with a plain mouse —
 * the user can't get to items that scrolled off-screen. Translate the
 * dominant vertical delta into horizontal scroll. Touchpads (which already
 * emit deltaX) and touch swipes are left untouched.
 *
 * Intentionally does NOT preventDefault: React attaches wheel listeners as
 * passive, and setting scrollLeft alone gives the desired effect.
 */
export function scrollHorizontallyOnWheel(e: WheelEvent<HTMLElement>) {
  const el = e.currentTarget;
  if (el.scrollWidth <= el.clientWidth) return;
  if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
    el.scrollLeft += e.deltaY;
  }
}
